import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Trophy, Calendar, Map, Download } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const badges = [{
    Icon: Trophy,
    text: '+480 sesiones completas'
  }, {
    Icon: Calendar,
    text: '240 semanas planificadas'
  }, {
    Icon: Map,
    text: 'Material para cancha'
  }, {
    Icon: Download,
    text: 'Acceso inmediato'
  }];
  return <section className="relative pt-5 pb-12 lg:pt-12 lg:pb-20 bg-white overflow-hidden" data-id="element-93">
      {/* Subtle background accent */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-brand-50 rounded-full blur-3xl -translate-y-1/3 translate-x-1/3 opacity-70 pointer-events-none" data-id="element-94"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-96">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-brand-50 text-brand-700 font-bold text-[11px] sm:text-xs uppercase tracking-wider mb-4 border border-brand-100" data-id="element-97">
            <Trophy className="w-4 h-4" data-id="element-98" />
            Para entrenadores de baby fútbol
          </div>

          <h1 className="text-3xl sm:text-4xl lg:text-6xl font-extrabold text-ink-900 leading-[1.05] mb-4 tracking-tight" data-id="element-99">
            Resolvé toda tu{' '}
            <span className="text-brand-500" data-id="element-100">temporada en 5 minutos</span>
          </h1>
        </motion.div>

        {/* Product mockup image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative mb-5" data-id="element-101">
          <div className="absolute inset-0 bg-brand-200/40 rounded-full blur-3xl opacity-60 pointer-events-none" data-id="element-102"></div>

          {/* CSS/SVG Mockup for 6 Tomos */}
          <div className="relative z-10 w-full max-w-[260px] sm:max-w-md lg:max-w-2xl mx-auto drop-shadow-2xl h-48 sm:h-64 lg:h-80 bg-ink-900 rounded-2xl overflow-hidden border-4 border-ink-800 flex flex-col items-center justify-center" data-id="element-103">
            <div className="absolute inset-0 opacity-20" style={{
            backgroundImage: 'linear-gradient(0deg, transparent 24%, rgba(255, 255, 255, .3) 25%, rgba(255, 255, 255, .3) 26%, transparent 27%, transparent 74%, rgba(255, 255, 255, .3) 75%, rgba(255, 255, 255, .3) 76%, transparent 77%, transparent), linear-gradient(90deg, transparent 24%, rgba(255, 255, 255, .3) 25%, rgba(255, 255, 255, .3) 26%, transparent 27%, transparent 74%, rgba(255, 255, 255, .3) 75%, rgba(255, 255, 255, .3) 76%, transparent 77%, transparent)',
            backgroundSize: '50px 50px'
          }} data-id="element-104"></div>
            <div className="relative z-10 text-center px-4" data-id="element-105">
              <h3 className="text-brand-400 font-black text-xl sm:text-3xl lg:text-5xl tracking-tighter mb-2" data-id="element-106">
                MEGA PACK
              </h3>
              <h2 className="text-white font-black text-2xl sm:text-4xl lg:text-6xl tracking-tighter mb-4" data-id="element-107">
                BABYFÚTBOL 2026
              </h2>
              <div className="inline-block bg-brand-500 text-white font-bold px-4 py-1 rounded-full text-sm sm:text-base" data-id="element-108">
                6 TOMOS INCLUIDOS
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-109">
          <p className="text-base sm:text-lg lg:text-xl text-ink-600 mb-5 leading-relaxed max-w-3xl mx-auto" data-id="element-110">
            Todo el material que necesitás para entrenar categorías de 4 a 12
            años. 240 semanas planificadas. 480 sesiones completas. 6 tomos. 6
            bonos exclusivos.{' '}
            <strong className="text-ink-900" data-id="element-111">
              Listo para abrir y dirigir.
            </strong>
          </p>

          <button onClick={scrollToPricing} className="group w-full sm:w-auto bg-brand-500 hover:bg-brand-600 text-white text-base sm:text-lg font-extrabold py-4 sm:py-5 px-8 sm:px-10 rounded-2xl shadow-cta hover:shadow-xl transition-all transform hover:-translate-y-0.5 inline-flex items-center justify-center gap-3" data-id="element-112">
            QUIERO ACCEDER AHORA
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-113" />
          </button>

          <p className="mt-3 text-xs sm:text-sm text-ink-500" data-id="element-114">
            🔒 Pago 100% seguro · Garantía de 7 días
          </p>

          {/* Trust badges */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 mt-8 max-w-4xl mx-auto" data-id="element-115">
            {badges.map((b, i) => {
            const Icon = b.Icon;
            return <div key={i} className="flex items-center gap-2 text-xs sm:text-sm font-semibold text-ink-700 bg-white border border-ink-100 px-3 py-2 rounded-xl shadow-soft" data-id="element-116">
                  <div className="w-5 h-5 rounded-full bg-brand-50 text-brand-600 flex items-center justify-center shrink-0" data-id="element-117">
                    <Icon className="w-3 h-3" data-id="element-118" />
                  </div>
                  <span className="text-left leading-tight" data-id="element-119">{b.text}</span>
                </div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}